module.exports = __webpack_public_path__ + "static/allgemein1-79bae1672431d02d1304e4d5fb96af88.png";